import type { ChessConstructor } from "../chess/chessTypes.ts";
import { enrichCourse } from "../lessons/enrich.ts";
import { importPgnCourse, type PgnCourseMeta } from "../lessons/importer.ts";
import { assertValidCourse } from "../lessons/repository.ts";
import { authoringSanity, qualitativeSnapshot } from "../lessons/authoring.ts";
import { validateSanityReport } from "../lessons/sanity.ts";
import type { LessonCourse } from "../lessons/schema.ts";

export function buildDeepPgnCourse(
  Chess: ChessConstructor,
  pgn: string,
  meta: PgnCourseMeta
): LessonCourse {
  const course = importPgnCourse(Chess, pgn, meta);
  enrichCourse(course, qualitativeSnapshot(course, meta.title || meta.id));
  assertValidCourse(course, Chess);
  const sanity = authoringSanity(course);
  const issues = validateSanityReport(course, sanity);
  if (issues.length) {
    throw new Error(issues.map((issue) => issue.message).join("; "));
  }
  return course;
}
